import { get, patch, post } from '../../helpers/api';

// Operator-drawn polygons that replace the Mapbox drive-time contour for places
// whose real extent is not a blob around a point — a campus, a stadium. Served
// under the admin app's global prefix like every other admin route.
const BASE = '/admin/place-boundaries';

// Surface the server's own message (self-intersecting ring, no operational
// station inside) instead of axios's generic "Request failed with status code".
// The drawing page renders this inline beside the shape the operator still has
// on screen, so the text has to survive.
const messageFrom = (e) =>
  e?.response?.data?.message ||
  e?.response?.data?.error ||
  e?.message ||
  'Request failed';

const fetchPlaceBoundaries = async () => {
  const { data } = await get(BASE);
  return Array.isArray(data) ? data : [];
};

const createPlaceBoundary = async ({ name, geometry }) => {
  try {
    const { data } = await post(BASE, { name, geometry });
    return data;
  } catch (e) {
    throw new Error(messageFrom(e));
  }
};

// Snapping happens server-side: the Roads API is a web service, and this app's
// Maps key is referrer-restricted for the JS API, so the browser cannot call it.
const snapPath = async (path) => {
  try {
    const { data } = await post(`${BASE}/snap`, { path });
    return data?.path ?? [];
  } catch (e) {
    throw new Error(messageFrom(e));
  }
};

const deactivatePlaceBoundary = async (id) => {
  try {
    const { data } = await patch(`${BASE}/${id}/deactivate`);
    return data;
  } catch (e) {
    throw new Error(messageFrom(e));
  }
};

export default {
  fetchPlaceBoundaries,
  createPlaceBoundary,
  snapPath,
  deactivatePlaceBoundary,
};
